import React from 'react';
import Svg from '@jg/svg';
import quoteIcon from './svgs/quote-il.svg';
import styles from './RichEditor.scss';
import CSSModules from 'react-css-modules';

interface RichEditorQuote {
  attributes?: React.HTMLAttributes<HTMLElement>;
}

const RichQuoteNode: React.StatelessComponent<RichEditorQuote> = ({
  attributes = {},
  children,
}) => {
  return (
    <div styleName="quote" className="jg-space-mbml">
      <Svg
        markup={quoteIcon}
        className={`${styles['quote-marks']} jg-icon jg-display-i`}
      />
      <p className="jg-space-mbn" {...attributes}>
        {children}
      </p>
    </div>
  );
};

export default CSSModules(RichQuoteNode, styles);



// WEBPACK FOOTER //
// ./src/components/RichEditor/RichQuoteNode.tsx